module.exports = __webpack_public_path__ + "img/waistband length.e0c1a4e2.png";